const { DeviceId } = ( window as any ).Capacitor?.Plugins ?? {};
const is_native = !!DeviceId;

export const DeviceIdPlugin = {
  isAvailable(): boolean
  {
    return is_native;
  },

  // Returns the reinstall-stable native id (Android ID, or the Keychain-pinned
  // vendor id on iOS), or null on web / Telegram where the plugin isn't present.
  async getAndroidId(): Promise<string | null>
  {
    if ( !is_native ) return null;
    try
    {
      const { androidId } = await DeviceId.getAndroidId();
      return androidId ?? null;
    }
    catch
    {
      return null;
    }
  },
};
